module.exports = __webpack_public_path__ + "img/logos.9aa19877.jpg";